<template>
  <article class="blog-category">
    <AppLink
      v-if="category?.PageUrl?.url"
      :to="`/${category.PageUrl.url}/`"
      class="blog-category__link"
    >
      <picture v-if="category?.Image?.url">
        <source
          :srcset="getProductImage(category.Image.url, 'f=rs:fit:500')"
          media="(min-width: 1024px)"
        >
        <source
          :srcset="getProductImage(category.Image.url, 'f=rs:fit:750')"
          media="(min-width: 768px)"
        >
        <source
          :srcset="getProductImage(category.Image.url, 'f=rs:fit:500')"
        >
        <img
          v-if="category?.Image?.url"
          :src="getProductImage(category.Image.url, 'f=rs:fit:500')"
          :width="category?.Image?.width"
          :height="category?.Image?.height"
          :alt="category?.Image?.alternativeText || category?.PageTitle"
          class="blog-category__image"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'low' : 'high'"
          :decoding="lazy ? 'async' : 'sync'"
        >
      </picture>

      <span
        v-if="category?.PageTitle"
        class="blog-category__button button"
      >
        {{ category.PageTitle }}
      </span>
    </AppLink>
  </article>
</template>

<script setup lang="ts">
defineProps<{
  category: any
  lazy: boolean
}>()
</script>

<style src="~layers/app/components/Blog/Category.css" />
